import { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Flex,
  Button,
  Text,
  Box,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ReactComponent as ArrowDown } from '../../assets/svgs/ArrowDownSelect.svg';
import FormikSelect from '../../components/forkmikselect';
import DataBox from '../../components/databox';
import useGetSellerBy_id from '../../api/queries/useGetSellerBy_id';
import useEditSellerProfile from '../../api/mutations/useEditSellerProfile';
import REJECTED_ITEM_ACTIONS from '../../constants/returnedItemActions';
import useGetCharities from '../../api/queries/useGetCharities';
import FormikInput from '../../components/formikinput';
import FormikTextArea from '../../components/formikinput';

const EditModal = ({ isOpen, onClose, sellerId }) => {
  const toast = useToast();
  const [seller, setSeller] = useState(null);

  const charityQuery = useGetCharities();
  const charities = charityQuery?.data || [];

  const sellerQuery = useGetSellerBy_id({
    _id: sellerId,
    fields: [
      '_id',
      'id',
      'first_name',
      'surname',
      'email_address',
      'city',
      'address',
      'postcode',
      'contact_number',
      'commission',
      'rejected_item_action',
      'charity',
    ],
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      _id: seller?._id,
      id: seller?.id,
      first_name: seller?.first_name,
      surname: seller?.surname,
      email_address: seller?.email_address,
      city: seller?.city,
      address: seller?.address,
      postcode: seller?.postcode,
      contact_number: seller?.contact_number,
      commission: seller?.commission * 100,
      rejected_item_action: seller?.rejected_item_action,
      donate_to_charity: seller?.donate_to_charity,
    },
    validationSchema: Yup.object({
      commission: Yup.number()
        .min(1, 'Commission must be greater than or equal to 1')
        .max(100, 'Commission must be less than or equal to 100')
        .required('This field is required'),
    }),

    onSubmit: values => editSeller(values),
  });

  console.log('formik Values', formik?.initialValues);
  console.log('sellerQuery Values', sellerQuery);
  useEffect(() => {
    const data = sellerQuery.data?.data;
    if (data) {
      setSeller(data);
      formik.setFieldValue('_id', data._id);
      formik.setFieldValue('id', data.id);
      formik.setFieldValue('first_name', data.first_name);
      formik.setFieldValue('surname', data.surname);
      formik.setFieldValue('email_address', data.email_address);
      formik.setFieldValue('city', data.city);
      formik.setFieldValue('address', data.address);
      formik.setFieldValue('postcode', data.postcode);
      formik.setFieldValue('contact_number', data.contact_number);
      formik.setFieldValue('commission', data.commission * 100);
      formik.setFieldValue('rejected_item_action', data.rejected_item_action);
      formik.setFieldValue('donate_to_charity', data.charity);
    } else setSeller(null);
    // console.log('Set Data', data);
  }, [sellerQuery.data]);

  const sellerMutation = useEditSellerProfile({});
  const editSeller = async values => {
    try {
      const result = await sellerMutation.mutateAsync({
        _id: values._id,
        first_name: values.first_name,
        surname: values.surname,
        city: values.city,
        postcode: values.postcode,
        address: values.address,
        email_address: values.email_address,
        contact_number: values.contact_number,
        commission: values.commission / 100,
        rejected_item_action: values.rejected_item_action,
        donate_to_charity: values.rejected_item_action === REJECTED_ITEM_ACTIONS.RETURN_TO_ME
          ? undefined
          : values.donate_to_charity,
      });
      toast({
        title: 'Updated seller succesfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    } catch (e) {
      toast({
        title: 'Failed to update seller',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      console.log(e);
    }
  };

  if (!seller && sellerQuery.isFetching) {
    return (
      <ModalContainer isOpen={isOpen} onClose={onClose} isSuccess={false}>
        <Flex flexDirection={'column'} alignItems={'center'} gap={'8px'}>
          <Text fontFamily={'gothic'} fontSize={14} textTransform={'uppercase'}>
            Loading Seller Data
          </Text>
          <Spinner />
        </Flex>
      </ModalContainer>
    );
  }

  if (!seller && !sellerQuery.isFetching) {
    return (
      <ModalContainer isOpen={isOpen} onClose={onClose} isSuccess={false}>
        <Flex flexDirection={'column'} alignItems={'center'} gap={'8px'}>
          <Text fontFamily={'gothic'} fontSize={14} textTransform={'uppercase'}>
            Failed to Load Seller Data
          </Text>
        </Flex>
      </ModalContainer>
    );
  }

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      isSuccess={true}
      isSubmitting={sellerMutation?.isLoading}
      handleSubmit={() => formik.handleSubmit()}
    >
      <Flex direction={'column'} w={'100%'} gap={4} marginBlock={4}>
        <Flex gap={'12px'}>
          <DataBox label={'Seller Id'} data={seller.id} />
        </Flex>
        <Flex gap={'12px'}>
          <FormikInput
            formik={formik}
            name={'first_name'}
            label={'First Name'}
            placeholder={"Enter seller's first name"}
          />
          <FormikInput
            formik={formik}
            name={'surname'}
            label={'Surname'}
            placeholder={"Enter seller's surname"}
          />
        </Flex>
        <Flex gap={'12px'}>
          <FormikInput
            formik={formik}
            name={'city'}
            label={'City'}
            placeholder={"Enter seller's city name"}
          />
          <FormikInput
            formik={formik}
            name={'postcode'}
            label={'Postcode'}
            placeholder={"Enter seller's postcode"}
          />
        </Flex>
        <Flex gap={'12px'}>
          <FormikTextArea
            formik={formik}
            name={'address'}
            label={'Address'}
            placeholder={"Enter seller's address"}
          />
        </Flex>
        <Flex gap={'12px'}>
          <FormikInput
            formik={formik}
            name={'email_address'}
            label={'Email Address'}
            placeholder={"Enter seller's email address"}
            disabled
          />

          {/* <DataBox  label={"Email Address"}  data={seller?.email_address}/> */}
          <FormikInput
            formik={formik}
            name={'contact_number'}
            label={'Contact Number'}
            placeholder={"Enter seller's contact number"}
          />
        </Flex>
        <Flex gap={'12px'}>
          <FormikInput
            formik={formik}
            name={'commission'}
            label={'Commission'}
            placeholder={"Enter seller's commission"}
            rightAdornment={
              <Text fontSize="sm" color="#000">
                %
              </Text>
            }
          />
          <FormikSelect
            formik={formik}
            name="rejected_item_action"
            label="Rejected Items Action"
          >
            <option value={REJECTED_ITEM_ACTIONS.DONATE_TO_CHARITY}>
              {REJECTED_ITEM_ACTIONS.DONATE_TO_CHARITY}
            </option>
            <option value={REJECTED_ITEM_ACTIONS.RETURN_TO_ME}>
              {REJECTED_ITEM_ACTIONS.RETURN_TO_ME}
            </option>
          </FormikSelect>
        </Flex>

        {formik.values.rejected_item_action ===
          REJECTED_ITEM_ACTIONS.DONATE_TO_CHARITY && (
          <FormikSelect
            formik={formik}
            name="donate_to_charity"
            label="Donate to Charity"
            placeholder={'Select one...'}
          >
            {charities.map(charity => (
              <option key={charity._id} value={charity._id}>
                {charity.name}
              </option>
            ))}
          </FormikSelect>
        )}
      </Flex>
    </ModalContainer>
  );
};

const ModalContainer = ({
  isOpen = () => {},
  onClose = () => {},
  isSuccess = false,
  isSubmitting = false,
  handleSubmit = () => {},
  children,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minH={'300px'}
        maxW={'800px'}
        borderRadius={16}
        padding={4}
        gap={8}
      >
        <ModalBody display={'flex'} flexDirection={'column'} gap={6}>
          <Text
            fontFamily={'PlusJakartaSansSemiBold'}
            fontSize={'24px'}
            lineHeight={'32px'}
            textTransform={'capitalize'}
            color={'#000000'}
          >
            Edit Seller Details
          </Text>
          <Box height="1px" width="100%" bg="#8A8F9333" mx="auto" />
          <Flex direction={'column'} gap={2}>
            <Text
              fontFamily={'PlusJakartaSansSemiBold'}
              fontSize={'16px'}
              lineHeight={'20px'}
              textTransform={'capitalize'}
              color={'#000000'}
            >
              Details
            </Text>
            <Flex
              border={'1px'}
              borderColor={'#D9D9D9'}
              borderStyle={'solid'}
              padding={4}
              borderRadius={6}
            >
              {children}
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Flex w={'100%'} justify={'flex-end'} gap={4}>
            <Button
              bg={'white'}
              border={'1px solid #000000'}
              color="#000000"
              borderRadius={8}
              paddingInline={16}
              textTransform={'uppercase'}
              onClick={onClose}
            >
              Close
            </Button>
            {isSuccess && (
              <Button
                onClick={handleSubmit}
                isDisabled={isSubmitting}
                bg={'#000000'}
                color="#FFFFFF"
                borderRadius={8}
                paddingInline={16}
                textTransform={'uppercase'}
                border={'1px solid #FFFFFF'}
                _disabled={{
                  bg: 'grey.500',
                  border: '1px solid #FFFFFF',
                  cursor: 'initial',
                  _hover: {
                    bg: 'grey.500',
                    border: '1px solid #FFFFFF',
                    cursor: 'initial',
                  },
                }}
              >
                {isSubmitting ? <Spinner /> : 'Save'}
              </Button>
            )}
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditModal;
